export enum EVictimsTypePerson {
  Civilian = 'Civilian',
  Agent = 'Agent'
}
